import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["diagnostico-de-atendimento-e-vendas"];

export const Route = createFileRoute("/diagnostico-de-atendimento-e-vendas")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/diagnostico-de-atendimento-e-vendas" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/diagnostico-de-atendimento-e-vendas" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
